/**
 * Build the booking-widget iframe URL for the "resume booking" flow.
 * The resume token is base64url(siteId:timestampSite:leadId). We validate it and
 * pass `id` (siteId) + `resume` (the token) to the widget, which fetches the lead
 * and pre-fills the form. When `lang` ("es" | "en") is given it's passed as
 * `?lang` so the widget renders in the client's language (the widget reads that
 * param; without it the form defaults to English). Returns "" if the base URL or
 * token is invalid.
 */
function decodeResumeToken(token) {
  try {
    const b64 = String(token).replace(/-/g, "+").replace(/_/g, "/");
    const pad = b64.length % 4 ? "=".repeat(4 - (b64.length % 4)) : "";
    const [siteId, timestampSite, leadId] = atob(b64 + pad).split(":");
    if (!siteId || !timestampSite || !leadId) return null;
    return { siteId, timestampSite, leadId };
  } catch {
    return null;
  }
}

function buildWidgetResumeUrl(baseUrl, token, lang) {
  if (!baseUrl || typeof baseUrl !== "string" || !token) return "";
  const parsed = decodeResumeToken(token);
  if (!parsed) return "";
  try {
    const url = new URL(baseUrl.trim());
    url.searchParams.set("id", parsed.siteId);
    url.searchParams.set("resume", token);
    if (lang) url.searchParams.set("lang", lang);
    return url.toString();
  } catch {
    return "";
  }
}

export { decodeResumeToken };
export default buildWidgetResumeUrl;
